import isEmpty from 'lodash/isEmpty'
import React, { FC } from 'react'

import { Tooltip } from '../../components/Tooltip'
import * as S from './GuestTagBadge.styles'
import { GuestTagBadgeProps } from './GuestTagBadge.types'
import { getBadgeColor, mapToTagStructure, sortTagsByHierarchy } from './GuestTagBadge.utils'

const GuestTagBadge: FC<GuestTagBadgeProps> = ({
  tags,
  tooltipPlacement = 'top',
  shouldRenderInline,
}) => {
  if (!tags || isEmpty(tags)) {
    return <div>–</div>
  }

  const mappedTags = mapToTagStructure(tags)
  const sortedTags = sortTagsByHierarchy(mappedTags)

  const formattedBadges = sortedTags.map(tagItem => {
    const badge = {
      badgeColor: getBadgeColor(tagItem.tag),
      children: tagItem.tag,
    }

    if (tagItem.reason) {
      return {
        ...badge,
        children: (
          <Tooltip content={tagItem.reason} placement={tooltipPlacement}>
            <span>{tagItem.tag}</span>
          </Tooltip>
        ),
      }
    }

    return badge
  })

  return (
    <S.StyledBadges
      shouldRenderInline={shouldRenderInline}
      badges={formattedBadges}
      maxDisplayAmount={1}
    />
  )
}

export { GuestTagBadge }
